import { forwardRef, useState } from "react";
import { Input } from 'reactstrap';
import { formatCurrency } from '../../../../../util/core/Currency';


const DecimalInput = forwardRef((props, ref) => {
    let [value, updateValue] = useState(props.value);
    let className = '';

    const handleChange = element => {
        const inputValue = element.target.value;
        const formattedValue = formatCurrency(inputValue);
        element.target.value = formattedValue;
        updateValue(formattedValue);
        props.onChange(element);
    };

    if (props.error) {
        className = "is-invalid";
    }
    return (
        <div ref={ref}>
            <Input
                id={'id_' + props.name}
                onChange={handleChange}
                className={className}
                value={value}
                type={props.type}
                name={props.name}
                maxLength={props.maxLength ? props.maxLength : 20}
                readOnly={props.readOnly}
                autoFocus={props.autoFocus ? true : false}
                onBlur={(e) => {
                    if (props.onBlur) props.onBlur(e);
                }}
            />
            {props.error && (
                <span
                    className="error invalid-feedback"
                    style={{ display: 'inline' }}>
                    {props.error}
                </span>
            )}
        </div>
    );
})
export default DecimalInput;
